export const CHECKOUT_URL = 'https://financial-literacy-ready.impultienda.ar/checkout'

export const BOX_IMAGE =
  'https://cdn.magicpatterns.com/uploads/x9PdsEZPa7AYK8tH1MS7Ni/205c4119-299f-4e4f-9051-a38ebf763c61.webp'

export const heroBadges: string[] = [
  '7-Day Money-Back Guarantee',
  'Complete 6-in-1 Teaching System',
  'A Full School Year Already Organized',
  'Ready-to-Teach Lessons & Activities',
  'Printable Worksheets & Assessments',
  'Answer Keys Included',
  'Middle & High School Ready',
]

export const organizedItems: string[] = [
  'Lessons',
  'Visual explanations',
  'Worksheets',
  'Real-life scenarios',
  'Activities',
  'Assessments',
  'Answer keys',
  'Projects',
  'Yearly planning',
]

export const systemPills: string[] = [
  '6 Complete Digital Volumes',
  'A Full School Year Organized',
  'Ready-to-Teach Lessons & Worksheets',
  'Real-Life Activities & Projects',
  'Assessments & Answer Keys',
  'Middle & High School Ready',
]

export interface Volume {
  label: string
  title: string
  subtitle: string
  color: string
  highlights: string[]
  footnote: string
}

export const volumes: Volume[] = [
  {
    label: 'Volume 1',
    title: 'Money, Income & Banking',
    subtitle: 'Build the Financial Foundations Students Need',
    color: '#1d4ed8',
    highlights: ['Needs vs. wants', 'Reading a paycheck', 'Gross vs. net pay', 'Checking & savings'],
    footnote: 'Open the lesson and teach.',
  },
  {
    label: 'Volume 2',
    title: 'Budgeting & Smart Spending',
    subtitle: 'Students don’t just learn what a budget is — they build one',
    color: '#15803d',
    highlights: ['Building a budget', 'Fixed vs. variable expenses', 'Comparison shopping', 'Financial goals'],
    footnote: 'Less theory. More real-life application.',
  },
  {
    label: 'Volume 3',
    title: 'Credit, Debt & Borrowing',
    subtitle: 'Make Credit Easier to Understand and Easier to Teach',
    color: '#1e40af',
    highlights: ['Credit cards', 'Interest', 'Loans & repayment', 'Borrowing risks'],
    footnote: '“Can I afford this? What will this really cost?”',
  },
  {
    label: 'Volume 4',
    title: 'Saving & Investing',
    subtitle: 'Turn Future Money Concepts Into Something Students Can See',
    color: '#a16207',
    highlights: ['Emergency funds', 'Compound growth', 'Risk & return', 'Diversification'],
    footnote: 'Show it. Practice it. Apply it.',
  },
  {
    label: 'Volume 5',
    title: 'Taxes, Insurance & Real-Life Finance',
    subtitle: 'Prepare Students for the Money Decisions They’ll Actually Face',
    color: '#166534',
    highlights: ['Tax basics', 'Insurance', 'Housing & transportation', 'Cost of living'],
    footnote: 'Teach the money skills they’ll actually use.',
  },
  {
    label: 'Volume 6',
    title: 'Projects, Assessments & Real-Life Application',
    subtitle: 'Bring the Entire Curriculum Together',
    color: '#1e3a8a',
    highlights: ['Budgeting simulations', 'Decision challenges', 'Unit assessments', 'Project rubrics'],
    footnote: 'From memorizing definitions to making real decisions.',
  },
]

export const insideItems: string[] = [
  'Visual teaching pages',
  'Printable worksheets',
  'Real-life scenarios',
  'Exit tickets',
  'Assessments',
  'Answer keys',
]

export interface Slide {
  title: string
  caption: string
  image: string
}

export const slides: Slide[] = [
  {
    title: 'What If Money Didn’t Exist? — barter vs. money visual lesson',
    caption: 'Visual teaching pages',
    image:
      'https://cdn.magicpatterns.com/uploads/qeHr4BPEpR72tzLb2DJJeB/Captura-de-pantalla-2026-09-29-a-la_s_-10.10.15_p._m..webp',
  },
  {
    title: 'The $200 Challenge — needs, wants and savings budget worksheet',
    caption: 'Real-life budgeting challenges',
    image:
      'https://cdn.magicpatterns.com/uploads/amWSv3FEqeB8TzrR5fxyVZ/Captura-de-pantalla-2026-09-29-a-la_s_-10.11.35_p._m..webp',
  },
  {
    title: 'Hours × Rate = Gross Earnings — practice worksheet with answer key',
    caption: 'Printable worksheets with answer keys',
    image:
      'https://cdn.magicpatterns.com/uploads/oeFbk6S9fxD3KPzdnCsPYL/Captura-de-pantalla-2026-09-29-a-la_s_-10.12.22_p._m..webp',
  },
  {
    title: 'Can You Find It? — reading a real pay stub activity',
    caption: 'Paycheck examples',
    image:
      'https://cdn.magicpatterns.com/uploads/b1bToT88WACpZacNWaRWPz/Captura-de-pantalla-2026-09-29-a-la_s_-10.13.49_p._m..webp',
  },
  {
    title: 'Two Accounts — Two Different Jobs: checking vs. savings sort activity',
    caption: 'Banking activities',
    image:
      'https://cdn.magicpatterns.com/uploads/x66eM6YzvZsghfGrSMNUZS/Captura-de-pantalla-2026-09-29-a-la_s_-10.14.35_p._m..webp',
  },
]

export interface Bonus {
  label: string
  title: string
  description: string
}

export const bonuses: Bonus[] = [
  {
    label: 'Bonus 1',
    title: 'The Financial Literacy Year Planner™',
    description: 'Plan the whole school year, from pacing to daily lessons.',
  },
  {
    label: 'Bonus 2',
    title: '100 Warm-Ups & Bell Ringers™',
    description: 'Quick activities to start every class in seconds.',
  },
  {
    label: 'Bonus 3',
    title: 'Real-Life Money Challenge Pack™',
    description: '30 ready-to-use financial decision simulations.',
  },
  {
    label: 'Bonus 4',
    title: 'Financial Literacy Assessment Pack™',
    description: 'Quizzes, unit tests, rubrics and answer keys.',
  },
  {
    label: 'Bonus 5',
    title: 'Games & Classroom Activities™',
    description: '30 games, team challenges and stations.',
  },
]

export interface Differentiator {
  title: string
  description: string
}

export const differentiators: Differentiator[] = [
  {
    title: 'Practical',
    description: 'Built around real money decisions.',
  },
  {
    title: 'Visual',
    description: 'Charts, cards and real financial documents.',
  },
  {
    title: 'Organized',
    description: 'Every week follows a clear progression.',
  },
  {
    title: 'Ready to Use',
    description: 'Print it. Project it. Teach it.',
  },
  {
    title: 'Built for Teachers',
    description: 'Removes the planning workload.',
  },
]

export const offerChecklist: string[] = [
  '6 Complete Volumes',
  '5 Strategic Bonuses',
  'A Full School Year',
  'Worksheets & Activities',
  'Assessments & Answer Keys',
  'Instant Digital Access',
]

export const offerAssurances: string[] = [
  'Instant Download',
  '7-Day Money-Back Guarantee',
  'No Monthly Fees',
  'Access From Computer or Tablet',
  'Print the Materials You Need',
]

export const differenceOneThings: string[] = [
  'one worksheet.',
  'Or one lesson.',
  'Or one unit.',
  'Or a random collection of activities.',
]

export const youKnowItems: string[] = [
  'what to teach',
  'what order to teach it in',
  'what activity to use',
  'what worksheet to print',
  'how students can practice',
  'how to assess understanding',
  'what answers to expect',
  'what comes next',
]

export const finalCtaPoints: string[] = [
  '6 Complete Volumes',
  '5 Strategic Bonuses',
  'A Full School Year',
  'Answer Keys Included',
]

export interface PurchaseNotice {
  name: string
  city: string
  minutesAgo: number
}

export const purchaseNotices: PurchaseNotice[] = [
  { name: 'Jessica M.', city: 'Austin, TX', minutesAgo: 3 },
  { name: 'Michael T.', city: 'Columbus, OH', minutesAgo: 8 },
  { name: 'Sarah L.', city: 'Denver, CO', minutesAgo: 14 },
  { name: 'David B.', city: 'Atlanta, GA', minutesAgo: 21 },
  { name: 'Emily R.', city: 'Phoenix, AZ', minutesAgo: 27 },
  { name: 'Chris P.', city: 'Charlotte, NC', minutesAgo: 35 },
  { name: 'Amanda K.', city: 'Portland, OR', minutesAgo: 42 },
  { name: 'Jason W.', city: 'Nashville, TN', minutesAgo: 51 },
]

export interface Faq {
  question: string
  answer: string[]
  bullets?: string[]
  closing?: string
}

export const faqs: Faq[] = [
  {
    question: 'What is FINANCIAL LITERACY READY™?',
    answer: [
      'FINANCIAL LITERACY READY™ is a complete digital Financial Literacy teaching system designed to help teachers organize and teach an entire school year without creating every lesson, activity, worksheet, and assessment from scratch.',
    ],
  },
  {
    question: 'Is this a physical product?',
    answer: [
      'No. FINANCIAL LITERACY READY™ is a digital resource.',
      'You receive access to the materials electronically so you can view, download, and print the resources you need.',
    ],
  },
  {
    question: 'Who is it designed for?',
    answer: [
      'It is primarily designed for Middle School and High School teachers teaching Financial Literacy, Personal Finance, Economics, Business Education, or related money-skills topics.',
    ],
  },
  {
    question: 'Is it suitable for new teachers?',
    answer: [
      'Yes.',
      'The structure is designed to reduce planning and give teachers a clear path to follow.',
      'You can open the appropriate section, review the material, and use the included activities and resources with your class.',
    ],
  },
  {
    question: 'Does it cover a full school year?',
    answer: [
      'Yes.',
      'FINANCIAL LITERACY READY™ is organized as a complete school-year teaching system covering the major areas of Financial Literacy.',
    ],
  },
  {
    question: 'What topics are included?',
    answer: ['The system covers:'],
    bullets: [
      'Money',
      'Income',
      'Paychecks',
      'Banking',
      'Budgeting',
      'Smart Spending',
      'Credit',
      'Debt',
      'Borrowing',
      'Saving',
      'Investing',
      'Taxes',
      'Insurance',
      'Cost of Living',
      'Real-Life Financial Decisions',
      'Projects',
      'Assessments',
    ],
    closing: 'and more.',
  },
  {
    question: 'Can I print the materials?',
    answer: [
      'Yes.',
      'The worksheets, activities, assessments, planners, and classroom resources are designed to be used digitally or printed when appropriate.',
    ],
  },
  {
    question: 'Are answer keys included?',
    answer: [
      'Yes.',
      'Answer keys and teacher guidance are included throughout the system where objective answers are required.',
    ],
  },
  {
    question: 'Are there monthly fees?',
    answer: ['No.', 'You pay once and receive access to the product.'],
  },
  {
    question: 'How quickly do I receive access?',
    answer: ['Access is delivered digitally after purchase.'],
  },
  {
    question: 'Can I use the materials on a computer or tablet?',
    answer: [
      'Yes.',
      'The resources can be viewed digitally and printable materials can be downloaded for classroom use.',
    ],
  },
  {
    question: 'What if it isn’t right for me?',
    answer: [
      'Your purchase includes a 7-day money-back guarantee according to the applicable guarantee terms.',
    ],
  },
]
